import { INotificationMessage } from "@fl/shared/src/types/messages";
import AlterMessageItem from "./items";

interface IProps {
  messages: INotificationMessage[];
  setMessages: React.Dispatch<React.SetStateAction<INotificationMessage[]>>;
  floating?: boolean;
}

const AlterMessages: React.FC<IProps> = ({
  messages,
  setMessages,
  floating = true,
}) => {
  const onUpdate = (item: INotificationMessage, index: number) => {
    const updated = [...messages];
    updated[index] = { ...item };
    setMessages(updated);
  };

  return (
    <div
      className={
        floating ? "floating-alerts-container" : " inline-alerts-container"
      }
    >
      {messages.map((item, index) => {
        return (
          <AlterMessageItem
            key={item.key}
            index={index}
            item={item}
            onUpdate={onUpdate}
          />
        );
      })}
    </div>
  );
};

export default AlterMessages;
